import { Avatar, Tooltip } from 'antd';
import './user-avatar.component.module.scss';

/* eslint-disable-next-line */
export interface UserAvatarComponentProps {
  user: {
    id: number;
    firstname: string;
    lastname: string;
    avatar?: string | null;
  };
  size?: number | 'small' | 'default' | 'large';
  withTooltip?: boolean;
  shape?: 'circle' | 'square';
}

export function UserAvatar(props: UserAvatarComponentProps) {
  const { user, size } = props;

  const shape = props.shape ? props.shape : 'circle';
  const style: any = shape === 'square' ? { borderRadius: 5 } : {};
  if (Number(size)) {
    style['fontSize'] = Number(size) / 2;
  }
  const avatarSize = size ? size : 24;
  let returnValue = null;

  if (user.avatar) {
    if (user.avatar.length > 0) {
      returnValue = (
        <Avatar
          size={avatarSize}
          src={user.avatar}
          shape={shape}
          style={style}
        />
      );
    }
  } else {
    returnValue = (
      <Avatar size={avatarSize} shape={shape} style={style}>
        {user.firstname[0]?.toUpperCase()}
        {user.lastname[0]?.toUpperCase()}
      </Avatar>
    );
  }

  if (props.withTooltip) {
    return (
      <Tooltip title={user.firstname + ' ' + user.lastname}>
        {returnValue}
      </Tooltip>
    );
  } else {
    return returnValue;
  }
}

export default UserAvatar;
